import { apiClient, getBlobApiV2 } from '../util/http';

export const getPayrollValueBandsChart = async ({ folhaIds, competenciaInicial, competenciaFinal }) => {
  const { data } = await apiClient.get('/dashboard/value-bands/chart', {
    params: { folhaIds, competenciaInicial, competenciaFinal },
  });

  return data;
};

export const getPayrollValueBandsDrillDown = async ({ folhaIds, competencia, faixaId }) => {
  const { data } = await apiClient.get('/dashboard/value-bands/drill-down', {
    params: { folhaIds, competencia, faixaId },
  });

  return data;
};

export const getPayrollValueBandsCooperatorEntries = async ({ folhaIds, competencia, cpf }) => {
  const { data } = await apiClient.get('/dashboard/value-bands/drill-down/lancamentos', {
    params: { folhaIds, competencia, cpf },
  });

  return data;
};

export const downloadPayrollValueBandsChart = ({ folhaIds, competenciaInicial, competenciaFinal }) =>
  getBlobApiV2('/dashboard/value-bands/chart/export', {
    params: { folhaIds, competenciaInicial, competenciaFinal },
  });

export const downloadPayrollValueBandsDrillDown = ({ folhaIds, competencia, faixaId, busca }) =>
  getBlobApiV2('/dashboard/value-bands/drill-down/export', {
    params: { folhaIds, competencia, faixaId, busca },
  });
